import React from 'react';
import gql from 'graphql-tag';
import { Dropdown } from '@storable/canaveral-components';
import useCurrentBuilderPage from '../../hooks/useCurrentBuilderPage';
import BuilderPagesMenu from '../../containers/BuilderPagesMenu';
import styles from './styles.scss';

const propTypes = {};

const defaultProps = {};

const BuilderPagesDropdown = () => {
  const currentPage = useCurrentBuilderPage();

  const { internalName, id, status: { context, icon } = {} } = currentPage;

  const toggle = (
    <Dropdown.Toggle
      context={context}
      icon={icon}
      pull="left"
    >
      {internalName}
    </Dropdown.Toggle>
  );

  const excludeIds = id ? [id] : undefined;

  return (
    <Dropdown
      className={styles.dropdown}
      toggle={toggle}
    >
      <BuilderPagesMenu
        excludeIds={excludeIds}
        title="Pages"
        className={styles.menu}
      />
    </Dropdown>
  );
};

BuilderPagesDropdown.propTypes = propTypes;
BuilderPagesDropdown.defaultProps = defaultProps;

BuilderPagesDropdown.fragments = {
  contexts: {
    currentPage: gql`
    fragment BuilderPagesDropdownCurrentPage on Page {
      internalName
      status {
        id
        context
        icon
      }
    }
    `,
  },
};

export default BuilderPagesDropdown;
